export default __webpack_public_path__ + "static/media/CalendarIcon.ffc17a95.svg";